import React,{useState,useEffect} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';
import "./table.css"

function AnswerField(props){
   
    let answers = props.answers
    
    const [value,setVal] = useState(answers[0])
    
    useEffect(()=>{
        if(props.data!=null){
            setVal(props.data)
        }
    },[props.data])
    useEffect(()=>{
        if(props.autoFill!=null){
            setVal(props.autoFill)
            var fEvent = {}
            fEvent.name = props.name
            fEvent.value = props.autoFill
            props.handler(fEvent)
        }
    },[props.autoFill])
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       
  
        props.handler(e)

    }
    const setValues= (value) =>{
        setVal(value)
        props.hanlder(value)
    }
    const event_name = props.name
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index}>{answer}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }

AnswerField.defaultProps ={
    useScore:false,
    data:null
}


class Questions_Table extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0,autoFill:null}
        
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    onChange = async (event,score_val)=>{
        const {name,value} = event.target
        await this.setState((prevState)=>({
            ...prevState,
            [name]: value,
            score:prevState.score + score_val
        }))
        
     }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state){
    //         this.props.handler(this.props.fieldName,this.state)
    //     }
    // }
    handleAutoFill= (e)=>{
       this.setState({autoFill:e.target.value})
    }
    render(){
        let questions = this.props.questions
        var counter = 0
        var answers;
        return(
            <div className={'table-container'}>
        {this.props.autoFilldata?
            <div className={'autofill-form'}>
             <Form >
            <Form.Group >
                <Form.Label className={'autoFormlabel'} >{this.props.YesNoLabel}</Form.Label>
                <Form.Control as={'select'} onChange={this.handleAutoFill} disabled={this.props.disabled} className={'autoForm'}>
                   {this.props.customAnswers? <>
                    
                    {this.props.customAnswers.map((a,i)=>(
                        <option key={i}>{a}</option>
                    ))}
                   </>:
                    
                    <><option></option>
                    <option>Yes</option>
                    <option>No</option></>}
                </Form.Control>
            </Form.Group>
        </Form>
        </div>:null}
        
            <Table responsive={true} bordered={false} size="md" hover={false} striped={false}>
               {!this.props.hideHeader && <thead>
                        <tr>
                            
                            <th>Question</th>
                            <th>Presence</th>
                        </tr>
                </thead>}
                <tbody>
                    {questions.map((question,index)=>{
                      
                        if("heading" in question || "subHeading" in question){
                            counter = 0
                        }
                        else if(!( "index" in question)){
                            counter++
                        }
                        answers= ["","Yes","No"]
                        if("type2"in question ){
                            if( question.type2 == null){
                                answers = ["","Yes","No","N/A"]
                            }
                            else if(question.type2 == 'NA'){
                                answers = ["","N/A"]
                            }
                        }
                        
                        return (
                        <>
                        {!("heading"  in question ||"subHeading" in question) ?
                            <tr key={index}>
                            <>
                                <td>{"index" in question?question.index:counter}. {question.title}</td>
                            <td width={400}>
                            {!("noAnswer" in question)&&<AnswerField name={question.name} autoFill={this.state.autoFill} handler={this.props.handler} data={this.props.data!=null?this.props.data[question.name]:null} disabled={this.props.disabled} answers={answers} fieldName={this.props.fieldName}/>}
                            
                            </td>
                           </>
                        </tr> :
                        <>
                            {"heading" in question && <tr>
                            
                                <th>{question.heading}</th>
                                <td></td>
                            </tr>}
                            <tr>
                            
                                <td>{question.subHeading}</td>
                                <td></td>
                            </tr>
                        </>}
                        </>
                    )})}
                </tbody>
            </Table>
            </div>
        )
    }
    
}
Questions_Table.defaultProps = {
    Scoring:false,
    score:null,
    data:null,
    autoFilldata:false,
    hideHeader:false,
    customAnswers:false
}


export default Questions_Table;